import { apiFetch } from '@/lib/api/client';
import type { CreateOrganizationInput, OrganizationView } from '@/features/organization/types';

/**
 * `GET /organizations/:id`. Tenant-scoped (ADR-026 Addendum, AO-2). Read
 * only - `PATCH /organizations/:id` requires `organizations:manage`, which
 * per docs/15 only a Platform Super Admin holds (ADR-020, "Rejected
 * Alternatives": an Organization Admin is deliberately read-only on the
 * organization profile), so no update call is exposed here.
 */
export async function getOrganization(id: string): Promise<OrganizationView> {
  return apiFetch<OrganizationView>(`/organizations/${id}`, { tenantScoped: true });
}

/**
 * `POST /organizations` (ADR-020; Phase G-7, Job 6). Platform Super Admin
 * only - NOT tenant-scoped, since the caller holds no organization of
 * their own yet (G-9, Job 6: the backend route/service/validation already
 * existed; this is the first client call to it).
 */
export async function createOrganization(
  input: CreateOrganizationInput,
): Promise<OrganizationView> {
  return apiFetch<OrganizationView>('/organizations', { method: 'POST', body: input });
}
